import moment from 'moment';
import { firebaseLogEvent } from '../firebase-config';

export const logEventWithUtcTime = (eventName: string, options: any) => {
  try {
    const utcTimeNow = moment().utc().format('YYYY-MMM-DD h:mm A');
    firebaseLogEvent(eventName, { utc_time: utcTimeNow, ...options });
  } catch (e) {
    //
  }
};
